<template>
	<div :class="`lines lines--${load} lines-up--${up} lines-reset--${reset}`">
		<div class="lines__content">
			<div class="lines__item lines__item--red"></div>
			<div class="lines__item lines__item--yellow"></div>
			<div class="lines__item lines__item--blue"></div>
			<div class="lines__item lines__item--purpure"></div>
		</div>
	</div>
</template>

<script>
	export default {
		props: {
			load: Boolean,
		},
		data() {
			return {
				up: false,
				reset: false,
			}
		},
		watch: {
			load(value) {
				if (value === true) {
					setTimeout(() => {
						this.up = true;
					}, 1200)
					setTimeout(() => {
						this.reset = true;
						this.up = false;
					}, 1900)
					setTimeout(() => {
						this.reset = false;
					}, 2500)
				}
			}
		}
	}
</script>

<style lang="sass">
	.lines
		position: fixed
		bottom: 0
		z-index: 10000
		height: vw(10px)
		width: 100%
		@media screen and (max-width: 1000px)
			height: vwm(10px)
		&.static
			position: relative
		&__content
			display: flex
			justify-content: space-between
		&__item
			width: 25%
			height: vw(10px)
			transition: all 200ms
			position: absolute
			top: 0
			@media screen and (max-width: 1000px)
				height: vwm(10px)
			&--red
				background-color: $red
			&--yellow
				background-color: $yellow
			&--blue
				background-color: $lightblue
			&--purpure
				background-color: $purpure
			&--red
				left: 0
				transition-duration: 300ms
			&--yellow
				left: 25%
				transition-duration: 500ms
			&--blue
				left: 50%
				transition-duration: 700ms
			&--purpure
				left: 75%
				transition-duration: 900ms
		&--true
			.lines__item
				height: calc(100vh + 100px)
				top: -100vh
				background-image: url(../assets/images/bg.png)
				&--red
					transition-duration: 600ms
				&--yellow
					transition-duration: 900ms
				&--blue
					transition-duration: 1200ms
				&--purpure
					transition-duration: 1500ms
		&-up--true
			.lines__item
				height: calc(100vh + 100px)
				top: -220vh !important
				background-image: url(../assets/images/bg.png)
		&-reset--true
			.lines__item
				transition: none
				opacity: 0
</style>